<template>
  <div id="app">
    <Header/>
    <News/>
    <Dates/>
    <Band/>
    <Videos/>
    <Footer/>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Dates from './components/Dates.vue'
import News from './components/News.vue'
import Band from './components/Band.vue'
import Videos from './components/Videos.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'app',
  components: {
    Header,
    Dates,
    News,
    Band,
    Videos,
    Footer
  }
}
</script>

<style>
@font-face {
  font-family: "Futura Condensed Regular";
	src: url("./assets/fonts/Futura Condensed Regular.ttf");
}
a{
  color: orangered;
  text-decoration: none;
  border-bottom: 1px solid orangered
}

html, body, h1, h2, h3, h4, h5, h6, ul, li {
  margin: 0;
  padding: 0;
  list-style-type: none;
  box-sizing: border-box;
}
html, body{
  overflow-x: hidden;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  font-size: 18px;
  font-family: "Futura Condensed Regular";
  background-color: #011310;
}

</style>
